class CursorPaginator {
    static get $inject() {
        return ['$scope']
    }

    constructor($scope) {
        this.currentPage = 1

        this.resetState()
        
        $scope.$on('hasNewRecords', () => {
            $scope.$apply(() => this.hasNewRecords = true)
        })
    }

    $onChanges({searchContext}) {
        if (searchContext)
            this.resetState()

        this.pageStart = (this.currentPage - 1) * this.perPage + 1
        this.pageEnd = (this.currentPage - 1) * this.perPage + this.currentPageSize
        
        if (!this.nextPage)
            this.totalCount = this.pageEnd
        
        if (this.pageStart === 1 && this.previousPage) {
            this.hasNewRecords = true
        }
    }

    resetState() {
        this.totalCount = null
        this.hasNewRecords = false
    }

    pagingAction(page) {
        this.onChange({ $page: page })
    }
}

angular.module('eficienciaFiscalModule')
    .component('cursorPaginator', {
        controller: CursorPaginator,
        bindings: {
            perPage: '<',
            nextPage: '<',
            previousPage: '<',
            currentPage: '<',
            currentPageSize: '<',
            searchContext: '<',
            onChange: '&'
        },
        //language=HTML
        template: `
            <div class="text-center" style="margin: 5px 0" ng-show="$ctrl.nextPage || $ctrl.previousPage">
                <button type="button" class="btn btn-default" 
                        ng-disabled="$ctrl.pageStart === 1 || !$ctrl.previousPage" 
                        ng-click="$ctrl.pagingAction({before: $ctrl.previousPage})">
                    <i class="fa fa-arrow-left"></i> Anterior
                </button>

                <button ng-if="$ctrl.hasNewRecords" type="button" class="btn btn-default" ng-click="$ctrl.pagingAction({})"
                        tooltip="Novos resultados foram adicionados ao filtro atual. Clique aqui para atualizar.">
                    <i class="fa fa-refresh"></i>
                </button>

                <button ng-show="$ctrl.currentPage" class="btn btn-default" disabled>
                    {{$ctrl.pageStart}} - {{$ctrl.pageEnd}} de {{$ctrl.totalCount || 'muitos'}}
                </button>

                <button type="button" class="btn btn-default" 
                        ng-disabled="!$ctrl.nextPage" 
                        ng-click="$ctrl.pagingAction({after: $ctrl.nextPage})">
                    Próxima <i class="fa fa-arrow-right"></i>
                </button>
            </div>
        `
    })
